export function toSelectOptions<T>(array: T[]) {
  return array.map((a) => ({
    label: `${a}`,
    value: a,
  }));
}
